export default {
  teamUid: 0,
  inviteList: [],
  inviteInfo: null
}
